import type { Brand } from "../types/brand";

/** Returns an ISO string for a date `days` before the current time. */
function daysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString();
}

export const MOCK_BRANDS: Brand[] = [
  {
    id: "b1",
    name: "Samsung",
    domain: "samsung.com",
    logoUrl: null,
    isActive: true,
    hasOemAdapter: true,
    hasDtcPricing: true,
    lastOemRefreshAt: daysAgo(10),
    adapterHealth: "healthy",
    productCount: 48,
    trackedProductCount: 20,
    pendingReviewCount: 0,
    categories: ["OLED TVs", "Mini-LED TVs", "QLED TVs", "Crystal UHD TVs"],
  },
  {
    id: "b2",
    name: "LG",
    domain: "lg.com",
    logoUrl: null,
    isActive: true,
    hasOemAdapter: true,
    hasDtcPricing: true,
    lastOemRefreshAt: daysAgo(70),
    adapterHealth: "degraded",
    productCount: 36,
    trackedProductCount: 20,
    pendingReviewCount: 6,
    categories: ["OLED TVs", "Mini-LED TVs", "LED/LCD TVs"],
  },
  {
    id: "b3",
    name: "TCL",
    domain: "tcl.com",
    logoUrl: null,
    isActive: true,
    hasOemAdapter: true,
    hasDtcPricing: false,
    lastOemRefreshAt: daysAgo(95),
    adapterHealth: "healthy",
    productCount: 22,
    trackedProductCount: 20,
    pendingReviewCount: 0,
    categories: ["Mini-LED TVs", "LED/LCD TVs"],
  },
  {
    id: "b4",
    name: "Hisense",
    domain: "hisense-usa.com",
    logoUrl: null,
    isActive: true,
    hasOemAdapter: true,
    hasDtcPricing: false,
    lastOemRefreshAt: null,
    adapterHealth: null,
    productCount: 18,
    trackedProductCount: 15,
    pendingReviewCount: 0,
    categories: ["Mini-LED TVs", "LED/LCD TVs"],
  },
];

export const MOCK_BRANDS_BY_NAME = [...MOCK_BRANDS].sort((a, b) => a.name.localeCompare(b.name));
